export function getUrlVariablesObjeto() {
  const url = document.location.href

  if (url.indexOf('?') > 0) {
    const getString = url.split('?')[1]

    const GET = getString.split('&')
    const get = {}

    for (let i = 0, l = GET.length; i < l; i++) {
      const tmp = GET[i].split('=')
      get[tmp[0]] = unescape(decodeURI(tmp[1]))
    }
    return get
  }
}
